import React from "react";

const isAuthenticated = (window as any).state.isAuthenticated;

export const GuestWatchlistCTA: React.FC = () => {
    if (isAuthenticated) return null;

    return (
        <div className="rounded-md border border-pink/40 bg-black/40 p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
                <div className="text-white font-semibold text-lg">
                    Save your Watchlist permanently
                </div>
                <div className="text-white/70 text-sm">
                    You’re using a temporary watchlist. Log in to store it in your account
                    and access it from any device.
                </div>
            </div>

            <div className="flex gap-2">
                <a
                    href="/login"
                    className="rounded-md bg-pink hover:bg-pink-lighter transition-colors text-white px-4 py-2 text-sm font-semibold text-center"
                >
                    Log in
                </a>
                <a
                    href="/registration"
                    className="rounded-md bg-primary-text hover:bg-white/10 transition-colors text-white px-4 py-2 text-sm font-semibold text-center"
                >
                    Sign up
                </a>
            </div>
        </div>
    );
};